<template>
  <v-container>
    <v-skeleton-loader
      v-if="load"
      class="mx-auto"
      type="list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader>
    <v-form v-if="!load" v-model="valid" lazy-validation>
      <!-- Section 1: Queixas -->
      <v-row>
        <v-col cols="12">
          <h3>Queixas</h3>
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            name="queixas"
            label="Queixas"
            rows="3"
            row-height="25"
            shaped
            v-model="form.queixas"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-divider />

      <!-- Section 2: Histórico Laboral -->
      <v-row>
        <v-col cols="12">
          <h3>Histórico Laboral</h3>
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            name="historicoLaboral"
            label="Histórico Laboral"
            rows="3"
            row-height="25"
            shaped
            v-model="form.historicoLaboral"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-divider />

      <!-- Section 3: Acidente de Trabalho -->
      <v-row>
        <v-col cols="12">
          <h3>Já sofreu acidente de trabalho?</h3>
        </v-col>
        <v-col cols="12">
          <v-radio-group v-model="form.sofreuAcidente" row>
            <v-radio label="Sim" value="Sim"></v-radio>
            <v-radio label="Não" value="Não"></v-radio>
          </v-radio-group>
        </v-col>

        <template v-if="form.sofreuAcidente === 'Sim'">
          <v-col cols="6">
            <v-checkbox v-model="form.acidenteAfastamento" label="Com afastamento" />
            <v-checkbox v-model="form.acidenteSequelas" label="Com sequela" />
          </v-col>
          <v-col cols="6">
            <v-checkbox v-model="form.acidenteSemAfastamento" label="Sem afastamento" />
            <v-checkbox v-model="form.acidenteSemSequelas" label="Sem sequela" />
          </v-col>
          <v-col cols="12">
            <v-textarea
              outlined
              name="obsAcidente"
              label="Observação sobre o acidente"
              rows="3"
              row-height="25"
              shaped
              v-model="form.obsAcidente"
            ></v-textarea>
          </v-col>
        </template>
      </v-row>
      <v-divider />

      <!-- Section 4: Afastamento INSS -->
      <v-row>
        <v-col cols="12">
          <h3>Afastamento INSS</h3>
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            name="afastamentoInss"
            label="Informações sobre afastamento INSS"
            rows="3"
            row-height="25"
            shaped
            v-model="form.afastamentoInss"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-divider />

      <!-- Section 5: Antecedentes Pessoais -->
      <v-row>
        <v-col cols="12">
          <h3>Antecedentes Pessoais</h3>
        </v-col>
        <v-col cols="6">
          <v-checkbox v-model="form.antecedentesComorbidades" label="Comorbidades" />
          <v-checkbox v-model="form.antecedentesCirurgias" label="Cirurgias prévias" />
        </v-col>
        <v-col cols="6">
          <v-checkbox v-model="form.antecedentesAcidentes" label="Acidentes prévios" />
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            name="obsAntecedentes"
            label="Observação sobre antecedentes"
            rows="3"
            row-height="25"
            shaped
            v-model="form.obsAntecedentes"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-divider />

      <!-- Section 6: Estilo de Vida -->
      <v-row>
        <v-col cols="12">
          <h3>Estilo de Vida</h3>
        </v-col>
        <v-col cols="12">
          <v-checkbox v-model="form.estiloFuma" label="Fumante" />
          <v-text-field
            outlined
            v-model="form.obsEstiloFuma"
            label="Observação sobre tabagismo"
            :disabled="!form.estiloFuma"
          />

          <v-checkbox v-model="form.estiloBebe" label="Consome álcool" />
          <v-text-field
            outlined
            v-model="form.obsEstiloBebe"
            label="Observação sobre consumo de álcool"
            :disabled="!form.estiloBebe"
          />

          <v-checkbox v-model="form.estiloAtividadeFisica" label="Pratica atividade física" />
          <v-text-field
            outlined
            v-model="form.obsEstiloAtividadeFisica"
            label="Observação sobre atividade física"
            :disabled="!form.estiloAtividadeFisica"
          />
        </v-col>
      </v-row>
      <v-divider />

      <!-- Section 7: Antecedentes Familiares -->
      <v-row>
        <v-col cols="12">
          <h3>Antecedentes Familiares</h3>
        </v-col>
        <v-col cols="6">
          <v-checkbox v-model="form.antecedentesHipertensao" label="Hipertensão" />
          <v-checkbox v-model="form.antecedentesDiabetes" label="Diabetes" />
        </v-col>
        <v-col cols="6">
          <v-checkbox v-model="form.antecedentesCardiopatias" label="Cardiopatias" />
          <v-checkbox v-model="form.antecedentesCancer" label="Câncer" />
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            name="obsAntecedentesFamiliares"
            label="Observação sobre antecedentes familiares"
            rows="3"
            row-height="25"
            shaped
            v-model="form.obsAntecedentesFamiliares"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-divider />

      <!-- Section 8: Exame Físico -->
      <v-row>
        <v-col cols="12">
          <h3>Exame Físico</h3>
        </v-col>
        <v-col cols="6">
          <v-text-field outlined v-model="form.altura" label="Altura" />
          <v-text-field outlined v-model="form.peso" label="Peso" />
          <v-text-field outlined v-model="form.frequenciaCardiaca" label="Frequência Cardíaca" />
          <v-text-field outlined v-model="form.pressaoArterial" label="Pressão Arterial" />
        </v-col>
        <v-col cols="6">
          <v-text-field outlined v-model="form.abdomen" label="Abdômen" />
          <v-text-field outlined v-model="form.temperatura" label="Temperatura" />
          <v-text-field outlined v-model="form.frequenciaRespiratoria" label="Frequência Respiratória" />
        </v-col>
        <v-col cols="12">
          <v-checkbox v-model="form.exameFisicoNormal" label="Exame físico normal" />
        </v-col>
      </v-row>
      <v-divider />

      <!-- Section 9: Conclusão -->
      <v-row>
        <v-col cols="12">
          <h3>Conclusão</h3>
        </v-col>
        <v-col cols="12">
          <v-radio-group v-model="form.conclusao" row>
            <v-radio label="Apto" value="Apto"></v-radio>
            <v-radio label="Inapto" value="Inapto"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <!-- Section 10: Recomendações -->
      <v-row>
        <v-col cols="12">
          <h3>Recomendações</h3>
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            name="recomendacoes"
            label="Recomendações"
            rows="3"
            row-height="25"
            shaped
            v-model="form.recomendacoes"
          ></v-textarea>
        </v-col>
      </v-row>

      <!-- Submit button -->
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="loadSave" text color="red" @click="$emit('voltar', 'voltar')">
          <v-icon left color="red">keyboard_return</v-icon>
          cancelar
        </v-btn>
        <v-btn :loading="loadSave" color="primary" :disabled="!valid" dark @click="cadastrarFichaExamesOS">
          <v-icon left>save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-container>
</template>

<script>

import medicoService from '../../services/medico.service'

export default {
  props: {
    idExamesOS: null
  },
  data () {
    return {
      valid: false,
      load: false,
      loadSave: false,
      form: {
        acidente: false,
        historicoObs: '',
        acidenteObs: '',
        exameFisicoNormal: false,
        sintomalogiaObs: `
        <label for="pa">PA:</label>
        <input type="text" id="pa" name="pa" size="5">  x  
        <input type="text" id="pa2" name="pa2" size="5"> mmHg<br><br>

        <label for="freq">Frequência cardíaca:</label>
        <input type="text" id="freq" name="freq" size="5"> bp/m<br><br>

        <label for="queixas">Queixas ou achados anormais ao:</label><br>
        <textarea id="queixas" name="queixas" rows="3" cols="50"></textarea><br><br>

        <label for="audiometria">Audiometria:</label><br>
        <input type="text" id="audiometria" name="audiometria" size="50"><br><br>

        <label for="ac_visual">Ac. Visual:</label><br>
        <input type="text" id="ac_visual" name="ac_visual" size="50"><br><br>

        <label for="vacina">Vacina:</label><br>
        <input type="text" id="vacina" name="vacina" size="50">`,
        idexamesos: null,
        queixas: '',
        historicoLaboral: '',
        sofreuAcidente: null,
        acidenteAfastamento: false,
        acidenteSequelas: false,
        acidenteSemAfastamento: false,
        pressaoArterial: null,
        acidenteSemSequelas: false,
        obsAcidente: null,
        afastamentoInss: '',
        antecedentesComorbidades: false,
        antecedentesCirurgias: false,
        antecedentesAcidentes: false,
        obsAntecedentes: '',
        estiloFuma: false,
        estiloBebe: false,
        estiloAtividadeFisica: false,
        obsEstiloFuma: null,
        obsEstiloBebe: null,
        obsEstiloAtividadeFisica: null,
        antecedentesHipertensao: false,
        antecedentesCardiopatias: false,
        antecedentesDiabetes: false,
        antecedentesCancer: false,
        obsAntecedentesFamiliares: '',
        altura: '',
        peso: '',
        frequenciaCardiaca: '',
        abdomen: '',
        temperatura: '',
        frequenciaRespiratoria: '',
        conclusao: null,
        recomendacoes: ''
      }
    }
  },
  methods: {
    unmask (str) {
      return str.replace(/[^\d]/g, '')
    },
    cadastrarFichaExamesOS () {
      this.form.idexamesos = this.idExamesOS
      this.loadSave = true
      medicoService.medico.cadastrarFichaExamesOS({ ficha: this.form }).then(r => {
        if (r.status == 200) {
          this.$emit('voltar', 'voltar')
        }
      }).finally(() => {
        this.loadSave = false
      })
    },
    buscarFichaExamesOS () {
      this.load = true
      medicoService.medico.buscarFichaExamesOS(this.idExamesOS).then(r => {
        if (r.status == 200) {
          console.log(r.data)
          this.form = r.data
        }
      }).finally(() => {
        this.load = false
      })
    }
  },
  watch: {
    'form.sofreuAcidente' (val) {
      if (val !== 'Sim') {
        this.form.acidenteAfastamento = null
        this.form.acidenteSequelas = null
        this.form.acidenteSemAfastamento = null
        this.form.acidenteSemSequelas = null
        this.form.obsAcidente = null
      }
    }
  },
  mounted () {
    this.buscarFichaExamesOS()
  }
}
</script>

<style scoped>
</style>
